import Input from './Input';

export interface DateRange {
    start: string;
    end: string;
}

interface DateRangeInputProps {
    id: string;
    label: string;
    value: DateRange;
    onChange: (value: DateRange) => void;
}

const DateRangeInput = ({ id, label, value, onChange }: DateRangeInputProps) => (
    <div>
        <span>{label}</span>
        <div className="row margin-top-1 align-items-center">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <label htmlFor={`${id}-start`} style={{ whiteSpace: 'nowrap', marginBottom: 0 }}>From</label>
                <Input
                    id={`${id}-start`}
                    type="date"
                    value={value.start}
                    disableAutocomplete={true}
                    onChange={(v) => onChange({ ...value, start: v })}
                />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginLeft: '8px' }}>
                <label htmlFor={`${id}-end`} style={{ whiteSpace: 'nowrap', marginBottom: 0 }}>To</label>
                <Input
                    id={`${id}-end`}
                    type="date"
                    value={value.end}
                    disableAutocomplete={true}
                    onChange={(v) => onChange({ ...value, end: v })}
                />
            </div>
        </div>
    </div>
);

export default DateRangeInput;
